import { Box, Container, Flex, Grid, Heading, Text } from '@chakra-ui/react';
import {
  AccordionItemContent,
  AccordionItemTrigger,
  AppLink,
  Badge,
  Image,
  pxToRem,
} from '@cyberkongz/ui';

import { CARDS_IRL } from './content/cards';
import {
  ActiveCardSidebar,
  CardItemWrapper,
  CardsSectionWrapper,
  IntroSectionWrapper,
  introTextStyles,
  useCardsSection,
} from './Shared';

function IntroSection() {
  return (
    <IntroSectionWrapper
      sxSection={{
        backgroundImage: 'url(/static/blueprint/irl/intro_bg.jpg)',
      }}
    >
      <Heading variant="displaySecondary">irl</Heading>
      <Heading lineHeight="base">
        EVENTS,
        <br /> COLLABORATIONS & more
      </Heading>
      <Text css={{ ...introTextStyles }}>
        CyberKongz is community-driven, and that is one of the elements that makes our project so
        special.
      </Text>
    </IntroSectionWrapper>
  );
}

function CardsSection() {
  const { activeItem, handleChange } = useCardsSection();
  const activeCardSidebar = activeItem ? (
    <ActiveCardSidebar {...CARDS_IRL[parseInt(activeItem)]} basePath="irl" />
  ) : null;

  return (
    <>
      <Container mb={6}>
        <Heading size="sm">Physical Goods</Heading>
      </Container>
      <CardsSectionWrapper
        {...{
          activeItem,
          handleChange,
          activeCardSidebar,
          sxBackground: {
            backgroundImage: 'url(/static/blueprint/irl/cards_bg.jpg)',
          },
        }}
      >
        {CARDS_IRL.map(({ title, description, badgeColor, badgeLabel, href, image }, i) => (
          <CardItemWrapper key={i} value={i}>
            <AccordionItemTrigger>
              <Flex css={{ justifyContent: 'space-between', alignItems: 'center', flex: 1 }}>
                <Badge badgeColor={badgeColor} withDot>
                  {badgeLabel}
                </Badge>
                <Box css={{ display: ['none', 'block'] }}>
                  <Image
                    src={image}
                    alt={title}
                    css={{ maxHeight: pxToRem(85), maxWidth: pxToRem(150) }}
                  />
                </Box>
              </Flex>
            </AccordionItemTrigger>
            <AppLink href={href} css={{ display: 'inline-block' }}>
              <Heading
                size="2xs"
                css={{
                  mt: [4, 12],
                  color: 'text',
                }}
              >
                {title}
              </Heading>
            </AppLink>
            <AccordionItemContent>
              <Box color="textSecondary">{description}</Box>
              <Box display={['block', 'none']}>{activeCardSidebar}</Box>
            </AccordionItemContent>
          </CardItemWrapper>
        ))}
      </CardsSectionWrapper>
    </>
  );
}

const BRAND_IMAGES = ['ua', 'virunga', 'christies', 'shapeways', 'chainlink'];

const EVENTS_IMAGES = ['nft_nyc', 'met_ams', 'veecon'];

function BrandsSection() {
  return (
    <Box pt={pxToRem(128)}>
      <Container>
        <Heading size="sm">Brand Collaborations</Heading>
        <Grid
          css={{
            gap: [3, 4, 6],
            mt: 10,
            gridTemplateColumns: ['repeat(2, 1fr)', 'repeat(4, 1fr)'],
          }}
        >
          {BRAND_IMAGES.map((image) => (
            <Image
              key={image}
              src={`/static/blueprint/irl/thumbnail_brand_${image}.png`}
              alt={image}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

function EventsSection() {
  return (
    <Box py={pxToRem(128)}>
      <Container>
        <Heading size="sm">Events</Heading>
        <Grid
          css={{
            gap: [3, 4, 6],
            mt: 10,
            gridTemplateColumns: ['repeat(2, 1fr)', 'repeat(4, 1fr)'],
          }}
        >
          {EVENTS_IMAGES.map((image) => (
            <Image
              key={image}
              src={`/static/blueprint/irl/thumbnail_event_${image}.png`}
              alt={image}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export function IRLTab() {
  return (
    <>
      <IntroSection />
      <CardsSection />
      <BrandsSection />
      <EventsSection />
    </>
  );
}
